const AdvenceFinicInput = [
    {
        key : 1,
        title:"Adevence Finance Video",
        video : "https://firebasestorage.googleapis.com/v0/b/form-b6d08.appspot.com/o/Etihad%20Group's%20CFO%20Saqib%20Riaz%20FCA%20Shares%20His%20Experience%20with%20Power%20BI%20Data%20Analysis%20_%20BrainAnalytics.mp4?alt=media&token=83d653c2-315c-4ce9-b707-a9967956bc1b",
    },
];
export default AdvenceFinicInput;